"use client";

// src/cookie-banner/index.tsx
import { useEffect as useEffect2, useRef } from "react";

// src/cookie-banner/useConsent.ts
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
var COOKIE_HAS_CONSENT_KEY = "r_hasConsent";
var COOKIE_CONSENTS_KEY = "r_consents";
var consentDefault = {
  required: true,
  analytics: false
};
var consentAll = {
  required: true,
  analytics: true
};
var declineAll = {
  required: true,
  analytics: false
};
function useConsent() {
  let host = void 0;
  if (typeof window !== "undefined") {
    const hostnameParts = window.location.hostname.split(".");
    if (hostnameParts.length > 2) {
      host = hostnameParts.slice(-2).join(".");
    } else {
      host = window.location.hostname;
    }
  }
  const cookies = new Cookies(null, {
    path: "/",
    maxAge: 31536e3,
    domain: host
  });
  const [hasConsent, setHasConsent] = useState(true);
  const [consent, setConsent] = useState(consentDefault);
  function updateConsent(value) {
    setConsent((current) => ({ ...current, ...value }));
  }
  function saveConsent(values = consentDefault) {
    cookies?.set(COOKIE_HAS_CONSENT_KEY, "true");
    cookies?.set(COOKIE_CONSENTS_KEY, values);
    setHasConsent(true);
    return values;
  }
  useEffect(() => {
    setHasConsent(!!cookies?.get(COOKIE_HAS_CONSENT_KEY));
    setConsent(cookies?.get(COOKIE_CONSENTS_KEY) || consentDefault);
  }, []);
  return {
    hasConsent,
    consent,
    acceptAll: () => saveConsent(consentAll),
    declineAll: () => saveConsent(declineAll),
    updateConsent,
    saveConsent
  };
}

// src/cookie-banner/index.tsx
import { Attention } from "@ds/illustrations";
import { Switch } from "@ds/switch";
import { Button } from "@ds/button";

// ../../node_modules/@ds/icons/index.esm.js
import { jsxs, jsx } from "react/jsx-runtime";
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function Cross(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Cross ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "m12 13.414 5.44 5.44a.5.5 0 0 0 .706 0l.708-.708a.5.5 0 0 0 0-.707L13.414 12l5.44-5.44a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L12 10.586l-5.44-5.44a.5.5 0 0 0-.706 0l-.708.708a.5.5 0 0 0 0 .707L10.586 12l-5.44 5.44a.5.5 0 0 0 0 .706l.708.708a.5.5 0 0 0 .707 0L12 13.414Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Cross {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Cross:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}

// src/cookie-banner/translation.ts
var translation = {
  en: {
    acceptAll: "Accept all",
    onlyRequired: "Only required",
    declineAll: "Decline alle",
    customize: "Customize",
    acceptRequired: "Accept only required",
    acceptSelected: "Save my selections",
    headerDrawer: "Our websites use cookies for security and analysis",
    link: "cookie policy",
    descriptionDrawer: "Learn more about which ones we use and how we manage them in our cookie statement. You can withdraw your consent at any time by selecting {{ link }} at the bottom of our pages.",
    header: "We use cookies",
    description: "Our websites use cookies for security and analysis. Learn more about which ones we use and how we manage them here: {{ link }}",
    required: {
      title: "Cookies are required",
      description: "To use Minside you must allow cookies."
    },
    consent: {
      analytics: {
        title: "Web Analytics",
        description: "We use analytics tools to gather anonymous statistics on how the websites are used, so that we can improve our service."
      },
      required: {
        title: "Essential Cookies (mandatory)",
        description: "We use some cookies that are necessary for the website to function as intended. Read more under {{ link }} about which cookies are strictly necessary."
      }
    }
  },
  no: {
    acceptAll: "Tillat alle",
    onlyRequired: "Kun n\xF8dvendige",
    declineAll: "Avsl\xE5 alle",
    customize: "Tilpass",
    acceptRequired: "Godta kun n\xF8dvendig",
    acceptSelected: "Lagre mine valg",
    headerDrawer: "V\xE5re nettsider benytter informasjonskapsler (cookies) til sikkerhet og analyse",
    link: "cookies-erkl\xE6ring",
    descriptionDrawer: "V\xE5re nettsider bruker informasjonskapsler (cookies) til sikkerhet og analyse. Les om v\xE5re informasjonskapsler her: {{ link }}.",
    header: "Vi bruker informasjonskapsler (cookies)",
    description: "V\xE5re nettsider benytter informasjonskapsler (cookies) til sikkerhet og analyse. Les mer om hvilke vi bruker og hvordan vi administrerer dem her: {{ link }}",
    required: {
      title: "Cookies er p\xE5krevd",
      description: "For \xE5 kunne bruke Minside m\xE5 du tillatte cookies."
    },
    consent: {
      analytics: {
        title: "Webanalyse",
        description: "Vi bruker analyseverkt\xF8y for \xE5 samle anonym statistikk om hvordan nettsidene brukes, slik at vi kan forbedre tjenesten v\xE5r."
      },
      required: {
        title: "N\xF8dvendige informasjonskapsler (ikke valgfritt)",
        description: "Vi bruker noen cookies som er n\xF8dvendige for at nettsiden skal kunne fungere som tiltenkt."
      }
    }
  }
};

// src/cookie-banner/replacer.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function TextReplace({
  text,
  content,
  replaceKey,
  className
}) {
  return /* @__PURE__ */ jsx2(
    "p",
    {
      className: className ? className : "",
      dangerouslySetInnerHTML: {
        __html: text.replace(`{{ ${replaceKey} }}`, `${content}`)
      }
    }
  );
}

// src/cookie-banner/index.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
function CookieBanner({
  lang,
  cookiesUrl,
  open,
  onClose,
  onConsentComplete
}) {
  const dialogRef = useRef(null);
  const {
    hasConsent,
    consent,
    updateConsent,
    saveConsent,
    acceptAll,
    declineAll: declineAll2
  } = useConsent();
  const t = lang && translation[lang] || translation.no;
  useEffect2(() => {
    if (open) {
      dialogRef.current?.showModal();
    }
  }, [open]);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx3(
      "dialog",
      {
        onClose,
        ref: dialogRef,
        className: "top-0 bottom-0 rounded-lg backdrop:backdrop-blur-sm max-w-md p-0 m-auto",
        children: /* @__PURE__ */ jsxs2("div", { className: "relative md:px-10 md:py-9 p-6 bg-background-primary rounded-lg", children: [
          /* @__PURE__ */ jsx3(Attention, { "aria-hidden": "true", className: "h-[152px] w-[152px] mb-5" }),
          /* @__PURE__ */ jsx3("h1", { className: "typography-title-small text-ink-primary mt-4 mb-0", children: t.header }),
          /* @__PURE__ */ jsx3(
            TextReplace,
            {
              text: t.description,
              replaceKey: "link",
              className: "typography-body-small text-ink-secondary mt-0",
              content: `<a class="underline" href="${cookiesUrl}">${t.link}</a>`
            }
          ),
          /* @__PURE__ */ jsx3("ul", { className: "mt-3", children: Object.entries(consent)?.map(
            ([key, value]) => /* @__PURE__ */ jsxs2("li", { className: "py-3 flex gap-5 items-center", children: [
              /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-3", children: [
                /* @__PURE__ */ jsx3("h2", { className: "typography-title-small text-ink-primary mb-4 mt-0", children: t.consent[key].title }),
                /* @__PURE__ */ jsx3(
                  TextReplace,
                  {
                    text: t.consent[key].description,
                    replaceKey: "link",
                    className: "typography-body-small text-ink-secondary mt-0",
                    content: `<a class="underline" href="${cookiesUrl}">${t.link}</a>`
                  }
                )
              ] }),
              key !== "required" && /* @__PURE__ */ jsx3(
                Switch,
                {
                  label: t.consent[key].title,
                  slotProps: {
                    label: {
                      className: "sr-only"
                    }
                  },
                  onChange: (event) => updateConsent({ [key]: !!event.target.checked }),
                  checked: value
                }
              )
            ] }, key)
          ) }),
          /* @__PURE__ */ jsx3(
            Button,
            {
              onClick: () => {
                saveConsent(consent);
                onConsentComplete?.(consent);
                dialogRef.current?.close();
              },
              className: "mt-5",
              children: t.acceptSelected
            }
          ),
          /* @__PURE__ */ jsx3(
            Button,
            {
              "aria-label": "Close",
              className: "absolute top-1 right-1",
              onClick: () => dialogRef.current?.close(),
              skin: "FLAT",
              startIcon: /* @__PURE__ */ jsx3(Cross, { className: "h-6 w-6 fill-fill-primary" })
            }
          )
        ] })
      }
    ),
    !hasConsent && /* @__PURE__ */ jsxs2(
      "div",
      {
        className: "fixed lg:flex-row gap-5 flex-col flex z-50 justify-between rounded-none bottom-0 left-0 right-0 m-auto bg-background-secondary md:px-10 md:py-9 p-6",
        style: {
          boxShadow: "0px 2px 20px 0px rgba(49, 54, 99, 0.08)"
        },
        children: [
          /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-2 max-w-md", children: [
            /* @__PURE__ */ jsx3("h1", { className: "typography-title-small text-ink-primary", children: t.headerDrawer }),
            /* @__PURE__ */ jsx3(
              TextReplace,
              {
                text: t.descriptionDrawer,
                replaceKey: "link",
                className: "typography-body-small text-ink-secondary mt-0",
                content: `<a class="underline" href="${cookiesUrl}">${t.link}</a>`
              }
            )
          ] }),
          /* @__PURE__ */ jsxs2("div", { className: "flex flex-col md:flex-row gap-3 mt-auto", children: [
            /* @__PURE__ */ jsx3(
              Button,
              {
                skin: "FLAT",
                className: "w-[100px]",
                onClick: () => dialogRef.current?.showModal(),
                children: t.customize
              }
            ),
            /* @__PURE__ */ jsx3(
              Button,
              {
                skin: "SECONDARY",
                className: "w-[160px]",
                onClick: () => {
                  const consentNone = declineAll2();
                  onConsentComplete?.(consentNone);
                },
                children: t.onlyRequired
              }
            ),
            /* @__PURE__ */ jsx3(
              Button,
              {
                onClick: () => {
                  const consentAll2 = acceptAll();
                  onConsentComplete?.(consentAll2);
                },
                className: "w-[150px]",
                children: t.acceptAll
              }
            )
          ] })
        ]
      }
    )
  ] });
}
export {
  CookieBanner
};
